import React from 'react';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import {
	Input,
	Alert,
	Button,
	Select,
	InputNumber,
	Card,
	Table,
	message,
	Col,
	Row,
	Popconfirm,
	Popover,
} from 'antd';
import { connect } from 'react-redux';
import { FormComponentProps } from '@ant-design/compatible/lib/form/Form';
import { withRouter } from 'react-router';
import {
	getConfigValueDefaultingToTrue,
	getCurrency,
	nullSafeGetWithZero,
	nullSafeGet,
	nullSafeGetOrElse,
	removeHydratedProps,
	sortById,
	stopDefaultEvents,
} from '../../utils/DataAccessUtils';
import BackButton from '../back_button/BackButton';
import { purchaseRequestsRestCrudThunksForSupplier } from '../../thunks/purchase_requests_thunks';
import { purchaseOrdersRestCrudThunksForSupplier } from '../../thunks/purchase_orders_thunks';
import { PurchaseRequestPartLineItemRowDisplay } from '../purchase_request_part_line_item_row_display/PurchaseRequestPartLineItemRowDisplay';
import { currencyFormatter } from '../../utils/DataFormatterUtils';
import OWAsyncSelect from '../ow_async_select/OWAsyncSelect';
import { OWButton } from '../ow_button/OWButton';
import { stockLocationsRestCrudThunksForSupplier } from '../../thunks/stock_locations_thunks';
import { AddressDisplay } from '../address_display/AddressDisplay';
import { vendorsRestCrudThunksForSupplier } from '../../thunks/vendors_thunks';
import { associatePurchaseRequestLineItemToPurchaseOrderForSupplier } from '../../thunks/purchase_request_line_items_thunks';
import { purchaseOrderLineItemsRestCrudThunksForSupplier } from '../../thunks/purchase_order_line_items_thunks';
import { debounce } from '../../utils/PerformanceUtils';
import FormDots from '../common/FormDots';
import EditPOLineItemModal from './EditPOLineItemModal';
import { locationsRestCrudThunksForSupplier } from '../../thunks/locations_thunks';
import { getRecordsForTargetCollection } from '../../reducers/standard_reducer_utils';
import InfoWithKeyValuePair from '../supplier_assets_detail_page/InfoWithKeyValuePair';
import PRWarrantyAssetDetail from '../purchase_requests_detail_details_page/PRWarrantyAssetDetail';
import { brandsRestCrudThunksForSupplier } from '../../thunks/brands_thunks';
import OWRichTextEditor from '../../rich_text_editor/OWRichTextEditor';
import { equipmentCatalogsRestCrudThunksForSupplier } from '../../thunks/equipment_catalogs_thunks';
import { partCatalogsRestCrudThunksForSupplier } from '../../thunks/part_catalogs_thunks';
import AddLineItemsToPOModal from './AddLineItemsToPOModal';
import ChangeVendorCurrencyComponent from '../vendors_detail_details_page/ChangeVendorCurrencyComponent';
import ClearErrors from '../clear_errors/ClearErrors';
import { PURCHASE_ORDERS_CRUD_ACTION_CREATORS } from '../../actions/purchase_orders_actions';
import { PURCHASE_ORDER_STATUSES } from '../../constants/PurchaseOrderStatuses';
import { StockLocationDropdownRecord } from '../StockLocationDropdownRecord';
import EquipmentPOLineItemWithViaSLDisplay from '../purchase_orders_detail_details_page/EquipmentPOLineItemWithViaSLDisplay';
import StagingSLDropDown from './StagingSLDropDown';
import {
	isForwardingAllowedBySettings,
	isGLCodeAllowedBySettings,
} from '../../utils/InventoryUtils';

const PURCHASE_ORDER_FORM_STOCK_LOCATION_DROPDOWN = 'purchaseOrderFormStockLocationDropdown';

require('./PurchaseOrderForm.less');

const VENDORS_TC = 'vendorsIndex';

interface PurchaseOrderFormProps extends FormComponentProps {
	creating: boolean;
	updating: boolean;
	formData: any;
	history: any;
	redirectForwardUrl?: string;
	onSuccess?: any;
	createErrors: any[];
	updateErrors: any[];
	purchaseOrders: any;
	purchaseRequests: any;
	stockLocations: any;
	onLineItemRemoved: any;
	vendors: any;
	addMoreLineItems: any;
	fetchStockLocations: any;
	fetchMultipleStockLocations: any;
	fetchPurchaseRequests: any;
	fetchVendor: any;
	currentUser: any;
	create: any;
	update: any;
	createLineItemsBulk: any;
	associatePurchaseRequestLineItemToPurchaseOrder: any;
	handleRemovePartFromCart: any;
	handleEditPart: any;
	handleUpdateLineItems: any;
	handleRemoveEquipmentFromCart: any;
	handleEditEquipment: any;
	onCancel?: any;
	fetchVendors: any;
	fetchMultipleVendors: any;
	locations: any;
	fetchLocations: any;
	fetchMultipleLocations: any;
	brands: any;
	fetchBrands: any;
	fetchMultipleBrands: any;
	fetchPartCatalog: any;
	fetchEquipmentCatalog: any;
	removeLineItemCosts: any;
	companySettings: any;
}

const WarrantyAssetCostFieldDisplay: React.FC<any> = ({
	currencyId,
	record,
	cost,
}): React.ReactElement => {
	const currency = getCurrency({ currencyId });
	return cost !== undefined ? (
		<div className="flex flex-row items-center">
			<div>{currency.format(cost)}</div>
			{record.warrantyAssetId ? (
				<InfoWithKeyValuePair
					details={{
						'Warranty Asset': (
							<PRWarrantyAssetDetail
								id={record.warrantyAssetId}
								asset={record.warrantyAsset}
								backLinkText={'Back To Purchase Order'}
								timeZoneId={nullSafeGet('supplierPurchaseOrder.location.timeZoneId', record)}
							/>
						),
					}}
				/>
			) : null}
		</div>
	) : (
		<>--</>
	);
};

class PurchaseOrderForm extends React.Component<PurchaseOrderFormProps, any> {
	state = {
		selectedRowKeys: [],
		editingLineItemDetails: {},
		editLineItemModalVisible: false,
		creatingPO: false,
		editorRef: React.createRef(),
		showAddPRLineItemsModal: false,
		addPRLineItemsIsEquipmentLine: false,
		currencyId: '',
		deletedLineItems: [],
	};

	getVendor = (vendorId) => {
		const { vendors, fetchVendor } = this.props;
		return new Promise((resolve, reject) => {
			const vendorRecords = getRecordsForTargetCollection(vendors, VENDORS_TC);
			const vendor = vendorRecords.find((_) => _.id === vendorId);
			if (vendor) {
				resolve(vendor);
			} else {
				fetchVendor(vendorId)
					.then((res) => resolve(res))
					.catch((err) => reject(err));
			}
		});
	};

	populateCosts = (vendorId) => {
		if (!vendorId) return;

		const { formData, fetchPartCatalog, fetchEquipmentCatalog, removeLineItemCosts } = this.props;

		this.getVendor(vendorId).then((vendor) => {
			if (
				nullSafeGet('currencyId', vendor) &&
				this.state.currencyId !== nullSafeGet('currencyId', vendor)
			) {
				this.setState({ currencyId: nullSafeGet('currencyId', vendor) });
				removeLineItemCosts && removeLineItemCosts();
				this.recalculateTotals();
				return;
			}

			const parts = nullSafeGetOrElse('partSupplierPurchaseOrderLineItems', formData, []);
			const partIds = parts.map((_) => _.partId).join(',');
			partIds &&
				fetchPartCatalog({
					partIds,
					partEquipmentVendorId: vendorId,
				}).then((catalogs) => this.handleCostFromPartCatalog(parts, catalogs));

			const equipmentTypes = nullSafeGetOrElse(
				'equipmentSupplierPurchaseOrderLineItems',
				formData,
				[]
			);
			const equipmentTypeIds = equipmentTypes.map((_) => _.equipmentTypeId).join(',');
			equipmentTypeIds &&
				fetchEquipmentCatalog({
					equipmentTypeIds,
					partEquipmentVendorId: vendorId,
				}).then((catalogs) => this.handleCostFromEquipmentCatalog(equipmentTypes, catalogs));
		});
	};

	componentDidMount() {
		const { formData, currentUser } = this.props;

		this.setState({
			currencyId:
				formData.currencyId ||
				nullSafeGet('partEquipmentVendor.currencyId', formData) ||
				nullSafeGet('id', getCurrency({ currentUser })),
		});
		this.recalculateTotals();
		this.populateCosts(nullSafeGet('partEquipmentVendorId', formData));
	}

	isAssetAvailable = (poLineItem) =>
		nullSafeGetOrElse('supplierPurchaseRequestLineItems', poLineItem, [])
			.map((_) => _.supplierPurchaseRequest)
			.some((_) => !!_ && !!_.asset);

	getDescription = () =>
		nullSafeGet('state.editorRef.current', this) &&
		(this.state.editorRef.current as any).getContent();

	handleSubmit = (e, submitAction) => {
		const { history, onSuccess, redirectForwardUrl, currentUser, formData, companySettings } =
			this.props;
		e.preventDefault();

		const isPoCostMandatory = getConfigValueDefaultingToTrue(
			companySettings,
			'inventoryConfig',
			'isPoCostMandatory'
		);

		this.props.form.validateFields((err, values) => {
			let newItemsAdded = false;

			if (!err) {
				const partItems = formData.partSupplierPurchaseOrderLineItems.map((partsKey) => {
					newItemsAdded = newItemsAdded || !partsKey.id;
					let partItem = {
						isEquipmentLine: false,
						partId: partsKey.partId,
						...(partsKey.partCatalog && { partCatalogId: partsKey.partCatalog.id }),
						partQuantity: parseInt(partsKey.partQuantity, 10),
						partCost:
							typeof partsKey.partCost !== 'undefined' ? parseFloat(partsKey.partCost) : undefined,
						partCurrencyId: this.state.currencyId,
						partUomId: 1,
						equipmentCurrencyId: this.state.currencyId,
						equipmentUomId: 1,
						prLineItemIds: partsKey.prLineItemIds,
						...(partsKey.warrantyAssetId && { warrantyAssetId: partsKey.warrantyAssetId }),
						hasAsset: this.isAssetAvailable(partsKey),
						glCode: partsKey.glCode,
					};
					return partItem;
				});

				const equipmentItems = formData.equipmentSupplierPurchaseOrderLineItems.map(
					(equipmentsKey) => {
						newItemsAdded = newItemsAdded || !equipmentsKey.id;
						return {
							isEquipmentLine: true,
							partCurrencyId: this.state.currencyId,
							partUomId: 1,
							equipmentTypeId: equipmentsKey.equipmentTypeId,
							...(equipmentsKey.equipmentCatalog && {
								equipmentCatalogId: equipmentsKey.equipmentCatalog.id,
							}),
							equipmentQuantity: parseInt(equipmentsKey.equipmentQuantity, 10),
							equipmentCost:
								typeof equipmentsKey.equipmentCost !== 'undefined'
									? parseFloat(equipmentsKey.equipmentCost)
									: undefined,
							equipmentCurrencyId: this.state.currencyId,
							equipmentUomId: 1,
							prLineItemIds: equipmentsKey.prLineItemIds,
							viaStockLocationId: equipmentsKey.viaStockLocationId,
							...(equipmentsKey.warrantyAssetId && {
								warrantyAssetId: equipmentsKey.warrantyAssetId,
							}),
							hasAsset: this.isAssetAvailable(equipmentsKey),
							glCode: equipmentsKey.glCode,
						};
					}
				);

				if ([...partItems, ...equipmentItems].length < 1) {
					message.error('Purchase order should contain at least one part/equipment!');
					return;
				}

				if (
					isPoCostMandatory &&
					[...partItems.map((_) => _.partCost), ...equipmentItems.map((_) => _.equipmentCost)].some(
						(_) => typeof _ === 'undefined'
					)
				) {
					message.error('Parts and Equipment should have cost!');
					return;
				}

				const purchase_order = {
					...formData,
					id: values.id,
					partEquipmentVendorId: values.partEquipmentVendorId,
					description: this.getDescription(),
					...(values.stockLocationId && { stockLocationId: values.stockLocationId }),
					...(values.locationId && { locationId: values.locationId }),
					freightTotalBeforeTax: values.freightTotalBeforeTax
						? parseFloat(values.freightTotalBeforeTax)
						: undefined,
					miscTotalBeforeTax: values.miscTotalBeforeTax
						? parseFloat(values.miscTotalBeforeTax)
						: undefined,
					totalBeforeTax: values.totalBeforeTax ? parseFloat(values.totalBeforeTax) : 0,
					tax: values.tax ? parseFloat(values.tax) : undefined,
					totalCost: values.totalCost ? parseFloat(values.totalCost) : 0,
					currencyId: this.state.currencyId,
					status: newItemsAdded ? 'new' : nullSafeGetOrElse('status', formData, 'new'),
					brandId: values.brandId,
					paymentTerms: values.paymentTerms,
					shippingTerms: values.shippingTerms,
					createdByEmail: currentUser.email,
					incomingLineItems: [...partItems, ...equipmentItems],
				};

				// Due date is stamped by the backend on the transition into `ordered`; the API
				// rejects it while the PO is still `new`, so strip any legacy value (e.g. from a
				// draft created before the form's due-date field was removed) from the payload.
				if (purchase_order.status === 'new') {
					delete purchase_order.dueDate;
				}

				this.setState({ creatingPO: true });

				submitAction(removeHydratedProps(purchase_order))
					.then((record) => {
						if (redirectForwardUrl) {
							history.push(redirectForwardUrl);
						}
						if (onSuccess) {
							onSuccess(record);
						}
					})
					.catch(message.error)
					.finally(() => this.setState({ creatingPO: false }));
			}
		});
	};

	hideEditLineItemModal = () => this.setState({ editLineItemModalVisible: false });

	handleEditPOPartLineItem = (record) => {
		this.setState({
			editingLineItemDetails: {
				type: 'part',
				cost: record.partCost,
				quantity: record.partQuantity,
				title: `Edit Part`,
				record,
			},
			editLineItemModalVisible: true,
		});
	};

	handleEditPOEquipmentLineItem = (record) => {
		this.setState({
			editingLineItemDetails: {
				type: 'equipment',
				cost: record.equipmentCost,
				quantity: record.equipmentQuantity,
				viaStockLocationId: record.viaStockLocationId,
				title: `Edit Equipment`,
				record,
			},
			editLineItemModalVisible: true,
		});
	};

	onEditLineItemSuccess = (totalQuantity, totalCost, viaStockLocation, glCode) => {
		const { handleEditPart, handleEditEquipment } = this.props;
		const { editingLineItemDetails } = this.state;
		if (nullSafeGet('type', editingLineItemDetails) === 'part') {
			handleEditPart({
				...nullSafeGet('record', editingLineItemDetails),
				partQuantity: totalQuantity,
				partCost: totalCost,
				glCode,
			});
		} else if (nullSafeGet('type', editingLineItemDetails) === 'equipment') {
			handleEditEquipment({
				...nullSafeGet('record', editingLineItemDetails),
				equipmentQuantity: totalQuantity,
				equipmentCost: totalCost,
				viaStockLocation,
				viaStockLocationId: nullSafeGet('id', viaStockLocation),
				glCode,
			});
		}
		this.hideEditLineItemModal();
		this.recalculateTotals();
	};

	recalculateTotals = debounce(() => {
		const { form, formData } = this.props;
		let accCost = 0.0;

		formData.partSupplierPurchaseOrderLineItems.forEach(
			(partItem) => (accCost = accCost + parseFloat(nullSafeGetOrElse('partCost', partItem, 0)))
		);

		formData.equipmentSupplierPurchaseOrderLineItems.forEach(
			(equipmentItem) =>
				(accCost = accCost + parseFloat(nullSafeGetOrElse('equipmentCost', equipmentItem, 0)))
		);

		const subtotals = form.getFieldsValue([
			'totalBeforeTax',
			'freightTotalBeforeTax',
			'miscTotalBeforeTax',
			'tax',
		]);

		form.setFieldsValue({
			totalBeforeTax:
				accCost +
				parseFloat(nullSafeGetOrElse('freightTotalBeforeTax', subtotals, 0)) +
				parseFloat(nullSafeGetOrElse('miscTotalBeforeTax', subtotals, 0)),
			totalCost:
				accCost +
				parseFloat(nullSafeGetOrElse('freightTotalBeforeTax', subtotals, 0)) +
				parseFloat(nullSafeGetOrElse('miscTotalBeforeTax', subtotals, 0)) +
				parseFloat(nullSafeGetOrElse('tax', subtotals, 0)),
		});
	}, 200);

	handleCostFromPartCatalog = (partLineItems, catalogs) => {
		const { handleEditPart } = this.props;
		if (catalogs && catalogs.length > 0) {
			catalogs.map((cat) => {
				const partLineItem = partLineItems.find((_) => _.partId === cat.partId);
				if (partLineItem && !partLineItem.id && partLineItem.warrantyAssetId) {
					handleEditPart({
						...partLineItem,
						partCatalog: cat,
						partCost: 0,
					});
					this.recalculateTotals();
				} else if (partLineItem && !partLineItem.partCost && cat.listPrice) {
					handleEditPart({
						...partLineItem,
						partCatalog: cat,
						partCost: cat.listPrice * nullSafeGetOrElse('partQuantity', partLineItem, 0),
					});
					this.recalculateTotals();
				}
			});
		}
	};

	handleCostFromEquipmentCatalog = (equipmentType, catalogs) => {
		const { handleEditEquipment } = this.props;
		if (catalogs && catalogs.length > 0) {
			catalogs.map((cat) => {
				const entity = equipmentType.find((_) => _.equipmentTypeId === cat.equipmentTypeId);
				if (entity && !entity.equipmentCost && cat.listPrice) {
					handleEditEquipment({
						...entity,
						equipmentCatalog: cat,
						equipmentCost: cat.listPrice * nullSafeGetOrElse('equipmentQuantity', entity, 0),
					});
					this.recalculateTotals();
				}
			});
		}
	};

	handleVendorChange = (vendorId) => {
		const { form } = this.props;
		this.getVendor(vendorId).then((vendor) => {
			const { setFieldsValue } = form;
			setFieldsValue({
				...(nullSafeGet('paymentTerms', vendor) && {
					paymentTerms: nullSafeGet('paymentTerms', vendor),
				}),
				...(nullSafeGet('shippingTerms', vendor) && {
					shippingTerms: nullSafeGet('shippingTerms', vendor),
				}),
			});

			this.populateCosts(vendorId);
		});
	};

	handleAddPRLineItem = (isEquipmentLine) => () => {
		this.setState({
			showAddPRLineItemsModal: true,
			addPRLineItemsIsEquipmentLine: !!isEquipmentLine,
		});
	};

	handleDeleteLineItem = (record) => {
		const { formData, handleUpdateLineItems } = this.props;
		const deletedItems = nullSafeGetOrElse('deletedLineItems', this.state, []);
		this.setState({ deletedLineItems: [...deletedItems, ...[record]] });

		const partLineItems = nullSafeGetOrElse('partSupplierPurchaseOrderLineItems', formData, []);
		const equipmentLineItems = nullSafeGetOrElse(
			'equipmentSupplierPurchaseOrderLineItems',
			formData,
			[]
		);

		const filterFn = (li) =>
			li.id
				? li.id !== record.id
				: li.isEquipmentLine
				? li.equipmentTypeId !== record.equipmentTypeId
				: li.partId !== record.partId;

		handleUpdateLineItems &&
			handleUpdateLineItems(partLineItems.filter(filterFn), equipmentLineItems.filter(filterFn));

		this.recalculateTotals();
	};

	onAddLineItemsSuccess = (addedItems) => {
		const { handleUpdateLineItems } = this.props;
		this.onAddPRLineItemsCancel();
		handleUpdateLineItems &&
			handleUpdateLineItems(addedItems.partLineItems, addedItems.equipmentLineItems);
		this.recalculateTotals();
	};

	onAddPRLineItemsCancel = () =>
		this.setState({
			showAddPRLineItemsModal: false,
		});

	onVendorUpdate = (vendor) => {
		this.handleVendorChange(vendor.id);
	};

	isLineItemEditable = (record) => {
		const NON_EDITABLE_STATUSES = [
			PURCHASE_ORDER_STATUSES.partially_received,
			PURCHASE_ORDER_STATUSES.received,
		];
		return !NON_EDITABLE_STATUSES.includes(record.status);
	};

	onStagingSLChange = (viaStockLocation) => {
		const { formData, handleEditEquipment } = this.props;
		const eqLineItems = nullSafeGetOrElse('equipmentSupplierPurchaseOrderLineItems', formData, []);
		eqLineItems.map((eqLineItem) =>
			setTimeout(
				() =>
					handleEditEquipment({
						...eqLineItem,
						viaStockLocation,
						viaStockLocationId: nullSafeGet('id', viaStockLocation),
					}),
				0
			)
		);
	};

	render() {
		const {
			form,
			update,
			create,
			stockLocations,
			fetchStockLocations,
			fetchMultipleStockLocations,
			locations,
			fetchLocations,
			fetchMultipleLocations,
			createErrors,
			formData,
			updateErrors,
			onCancel,
			vendors,
			fetchVendors,
			fetchMultipleVendors,
			brands,
			fetchBrands,
			fetchMultipleBrands,
			companySettings,
		} = this.props;
		const { getFieldDecorator, getFieldValue } = form;
		const isUpdate = formData && formData.id !== undefined;
		const submitAction = isUpdate ? update : create;
		const submitText = isUpdate ? 'Update purchase order' : 'Create purchase order';
		const stockLocationId = getFieldValue('stockLocationId');
		const locationId = getFieldValue('locationId');

		const canAddNewPRItems = !!nullSafeGet('id', formData);

		const glCodeEnabled = isGLCodeAllowedBySettings(companySettings);

		const poPartLineItemsColumns = [
			{
				title: 'Part Number',
				dataIndex: ['part', 'partNumber'],
			},
			{
				title: 'Part Detail',
				dataIndex: 'partId',
				render: (text, record) => (
					<PurchaseRequestPartLineItemRowDisplay
						titleLength={32}
						purchaseRequestPartLineItem={record}
					/>
				),
			},
			...(glCodeEnabled
				? [
						{
							title: 'GL Code',
							dataIndex: 'glCode',
						},
				  ]
				: []),
			{
				title: 'Quantity',
				dataIndex: 'partQuantity',
				render: (_, record) => (
					<div className="flex flex-row items-center">
						<div style={{ whiteSpace: 'nowrap' }}>
							{nullSafeGetOrElse('partQuantity', record, '--')}{' '}
							{nullSafeGetOrElse('partQuantity', record, 0) > 1
								? nullSafeGet('partUom.displayNamePlural', record)
								: nullSafeGet('partUom.displayNameSingular', record)}
						</div>
					</div>
				),
			},
			{
				title: 'Unit Cost',
				render: (_, record) => (
					<WarrantyAssetCostFieldDisplay
						currencyId={this.state.currencyId}
						record={record}
						cost={
							record.partCost !== undefined
								? nullSafeGetOrElse('partCost', record, 0) /
								  nullSafeGetOrElse('partQuantity', record, 1)
								: undefined
						}
					/>
				),
			},
			{
				title: 'Total Cost',
				dataIndex: 'partCost',
				render: (_, record) => (
					<WarrantyAssetCostFieldDisplay
						currencyId={this.state.currencyId}
						record={record}
						cost={_}
					/>
				),
			},
			{
				title: 'Actions',
				dataIndex: 'id',
				render: (id, record) => {
					const canEdit = this.isLineItemEditable(record);
					return (
						<Popover
							trigger="hover"
							content={canEdit ? '' : 'Received items cannot be edited or removed!'}
						>
							<div className="flex flex-row items-center">
								<Button
									icon={<EditOutlined title="Edit Cost" />}
									type="text"
									disabled={!canEdit}
									onClick={() => this.handleEditPOPartLineItem(record)}
								/>

								<div>
									<Popconfirm
										title={'Are you sure, you want to remove this part?'}
										onConfirm={(e) => {
											stopDefaultEvents(e);
											this.handleDeleteLineItem(record);
										}}
										onCancel={(e) => stopDefaultEvents(e)}
										okText="Yes"
									>
										<Button
											icon={<DeleteOutlined title="Delete" />}
											type="text"
											disabled={!canEdit}
										/>
									</Popconfirm>
								</div>
							</div>
						</Popover>
					);
				},
			},
		];

		const poEquipmentLineItemsColumns = [
			{
				title: 'Equipment Type #',
				dataIndex: ['equipmentType', 'equipmentTypeNumber'],
			},
			{
				title: 'Equipment Detail',
				dataIndex: 'equipmentTypeId',
				render: (text, record) => <EquipmentPOLineItemWithViaSLDisplay lineItem={record} />,
			},
			...(glCodeEnabled
				? [
						{
							title: 'GL Code',
							dataIndex: 'glCode',
						},
				  ]
				: []),
			{
				title: 'Quantity',
				dataIndex: 'equipmentQuantity',
			},
			{
				title: 'Unit Cost',
				render: (_, record) => (
					<WarrantyAssetCostFieldDisplay
						currencyId={this.state.currencyId}
						record={record}
						cost={
							record.equipmentCost !== undefined
								? nullSafeGetOrElse('equipmentCost', record, 0) /
								  nullSafeGetOrElse('equipmentQuantity', record, 1)
								: undefined
						}
					/>
				),
			},
			{
				title: 'Total Cost',
				dataIndex: 'equipmentCost',
				render: (_, record) => (
					<WarrantyAssetCostFieldDisplay
						currencyId={this.state.currencyId}
						record={record}
						cost={_}
					/>
				),
			},
			{
				title: 'Actions',
				dataIndex: 'id',
				render: (id, record) => {
					const canEdit = this.isLineItemEditable(record);
					return (
						<Popover
							trigger="hover"
							content={canEdit ? '' : 'Received items cannot be edited or removed!'}
						>
							<div className="flex flex-row items-center">
								<Button
									icon={<EditOutlined title="Edit Cost" />}
									type="text"
									disabled={!canEdit}
									onClick={() => this.handleEditPOEquipmentLineItem(record)}
								/>

								<div>
									<Popconfirm
										title={'Are you sure, you want to remove this part?'}
										onConfirm={(e) => {
											stopDefaultEvents(e);
											this.handleDeleteLineItem(record);
										}}
										onCancel={(e) => stopDefaultEvents(e)}
										okText="Yes"
									>
										<Button
											icon={<DeleteOutlined title="Delete" />}
											type="text"
											disabled={!canEdit}
										/>
									</Popconfirm>
								</div>
							</div>
						</Popover>
					);
				},
			},
		];

		const location = locationId
			? nullSafeGet(`${locationId}`, locations.records)
			: nullSafeGet(`${stockLocationId}.location`, stockLocations.records);

		const shipToPrefix = nullSafeGet('locationType.name', location)
			? `${nullSafeGet('locationType.name', location)} ${location.storeId}`
			: null;

		const shipToAddress = locationId
			? nullSafeGet(`${locationId}.buyerFacility.primaryAddress`, locations.records)
			: nullSafeGet(`${stockLocationId}.address`, stockLocations.records)
			? nullSafeGet(`${stockLocationId}.address`, stockLocations.records)
			: nullSafeGet(
					`${stockLocationId}.location.buyerFacility.primaryAddress`,
					stockLocations.records
			  )
			? nullSafeGet(
					`${stockLocationId}.location.buyerFacility.primaryAddress`,
					stockLocations.records
			  )
			: null;

		const defaultBrandId = locationId
			? nullSafeGet(`${locationId}.brandId`, locations.records)
			: nullSafeGet(`${stockLocationId}.location.brandId`, stockLocations.records);

		getFieldDecorator('id', { initialValue: formData.id });
		getFieldDecorator('partEquipmentVendorId', { initialValue: formData.partEquipmentVendorId });
		getFieldDecorator(`totalBeforeTax`, {
			initialValue: nullSafeGet(`totalBeforeTax`, formData),
		});

		getFieldDecorator(`totalCost`, {
			initialValue: nullSafeGet(`totalCost`, formData),
		});

		getFieldDecorator(`brandId`, {
			initialValue: nullSafeGet(`brandId`, formData) || defaultBrandId,
		});

		const allowViaStockLocation =
			nullSafeGet('locationId', formData) && isForwardingAllowedBySettings(companySettings);

		//TODO: UPGRADE FORM
		return (
			<Form
				layout="vertical"
				onSubmit={(e) => this.handleSubmit(e, submitAction)}
				className="purchaseOrderForm"
			>
				<ClearErrors actionCreators={PURCHASE_ORDERS_CRUD_ACTION_CREATORS} />
				{createErrors.length > 0 ? (
					<Form.Item>
						<Alert message={createErrors.join(' ')} type="error" />
					</Form.Item>
				) : null}
				{updateErrors.length > 0 ? (
					<Form.Item>
						<Alert message={updateErrors.join(' ')} type="error" />
					</Form.Item>
				) : null}

				<div className="rowSpacing">
					<div style={{ marginBottom: 12 }}>
						<h5 style={{ marginBottom: 0 }}>Details</h5>
					</div>
					<Card>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<Form.Item label="Vendor" style={{ flex: 1, marginRight: 24 }}>
								{nullSafeGet('partEquipmentVendorId', formData) ? (
									<div style={{ lineHeight: '38px' }}>
										{nullSafeGet(`partEquipmentVendor.name`, formData)}
									</div>
								) : (
									getFieldDecorator('partEquipmentVendorId', {
										initialValue: formData.partEquipmentVendorId,
										rules: [
											{
												required: true,
												message: 'Please select a vendor',
											},
										],
									})(
										<OWAsyncSelect
											style={{ maxWidth: 300 }}
											stateSlice={vendors}
											targetCollectionName={VENDORS_TC}
											onChange={this.handleVendorChange}
											fetchMultiple={(ids, targetCollectionName) => {
												fetchMultipleVendors(ids, targetCollectionName);
											}}
											fetchData={(
												searchText,
												targetCollectionName,
												pagination,
												sorting,
												filters,
												addToTargetCollection
											) => {
												fetchVendors(
													{ name: searchText },
													targetCollectionName,
													pagination,
													sorting,
													filters,
													addToTargetCollection
												);
											}}
											renderRecord={(v) => (
												<Select.Option key={v.id} value={v.id}>
													{v.name}
												</Select.Option>
											)}
										/>
									)
								)}
							</Form.Item>
							<Form.Item label="Currency" style={{ flex: 1, marginRight: 24 }}>
								{this.state.currencyId ? (
									<div className="flex flex-row items-center">
										<div>{this.state.currencyId}</div>
										{getFieldValue('partEquipmentVendorId') && !formData.id ? (
											<ChangeVendorCurrencyComponent
												vendorId={getFieldValue('partEquipmentVendorId')}
												onSuccess={this.onVendorUpdate}
											/>
										) : null}
									</div>
								) : null}
							</Form.Item>
							<Form.Item label="Ship to" style={{ flex: 1, marginRight: 24 }}>
								{formData.locationId
									? getFieldDecorator('locationId', {
											initialValue: formData.locationId,
									  })(
											<OWAsyncSelect
												disabled
												key="locationDropdown"
												style={{ maxWidth: 300 }}
												stateSlice={locations}
												targetCollectionName={'locationsIndex'}
												fetchMultiple={(ids, targetCollectionName) => {
													fetchMultipleLocations(ids, targetCollectionName);
												}}
												fetchData={(
													searchText,
													targetCollectionName,
													pagination,
													sorting,
													filters,
													addToTargetCollection
												) => {
													fetchLocations(
														{ name: searchText },
														targetCollectionName,
														pagination,
														sorting,
														filters,
														addToTargetCollection
													);
												}}
												renderRecord={(location) => (
													<Select.Option key={location.id} value={location.id}>
														{location.name}
													</Select.Option>
												)}
											/>
									  )
									: getFieldDecorator('stockLocationId', {
											initialValue: formData.stockLocationId,
									  })(
											<OWAsyncSelect
												disabled
												key="stockLocationDropdown"
												style={{ maxWidth: 300 }}
												stateSlice={stockLocations}
												targetCollectionName={PURCHASE_ORDER_FORM_STOCK_LOCATION_DROPDOWN}
												fetchMultiple={(ids, targetCollectionName) => {
													fetchMultipleStockLocations(ids, targetCollectionName);
												}}
												fetchData={(
													searchText,
													targetCollectionName,
													pagination,
													sorting,
													filters,
													addToTargetCollection
												) => {
													fetchStockLocations(
														{ name: searchText },
														targetCollectionName,
														pagination,
														sorting,
														filters,
														addToTargetCollection
													);
												}}
												renderRecord={(record) => (
													<Select.Option key={`${record.id} - ${record.name}`} value={record.id}>
														<StockLocationDropdownRecord record={record} />
													</Select.Option>
												)}
											/>
									  )}
							</Form.Item>
						</div>
						<div style={{ display: 'flex', marginTop: 16 }}>
							<Form.Item label="Brand" style={{ flex: 1, marginRight: 24 }}>
								{getFieldDecorator('brandId', {
									initialValue: formData.brandId || defaultBrandId,
								})(
									<OWAsyncSelect
										style={{ maxWidth: 300 }}
										stateSlice={brands}
										targetCollectionName={'poBrandsIndex'}
										fetchMultiple={(ids, targetCollectionName) => {
											fetchMultipleBrands(ids, targetCollectionName);
										}}
										fetchData={(
											searchText,
											targetCollectionName,
											pagination,
											sorting,
											filters,
											addToTargetCollection
										) => {
											fetchBrands(
												{ name: searchText },
												targetCollectionName,
												pagination,
												sorting,
												filters,
												addToTargetCollection
											);
										}}
										renderRecord={(b) => (
											<Select.Option key={b.id} value={b.id}>
												{b.brandName}
											</Select.Option>
										)}
									/>
								)}
							</Form.Item>
							<Form.Item label="Shipping Address" style={{ flex: 1, marginRight: 24 }}>
								{shipToAddress ? (
									<AddressDisplay
										prefix={shipToPrefix}
										style={{ lineHeight: 'auto' }}
										address={shipToAddress}
									/>
								) : null}
							</Form.Item>
						</div>
					</Card>
				</div>
				<div className="rowSpacing">
					<Row>
						<Col style={{ paddingRight: 12, marginBottom: 12 }} span={16}>
							<Card style={{ height: '100%' }}>
								<Form.Item label="Description" style={{ flex: 1, marginRight: 24 }}>
									{getFieldDecorator('description', {
										initialValue: nullSafeGet('description', formData),
										valuePropName: 'initialEditorState',
									})(
										<OWRichTextEditor
											initialEditorState={formData.description}
											editorRef={this.state.editorRef}
										/>
									)}
								</Form.Item>
							</Card>
						</Col>
						<Col span={8}>
							<div className="rowSpacing">
								<Card>
									<Form.Item label="Payment terms" style={{ flex: 1, marginRight: 24 }}>
										{getFieldDecorator('paymentTerms', {
											initialValue:
												nullSafeGet('paymentTerms', formData) ||
												nullSafeGet('partEquipmentVendor.paymentTerms', formData),
											//valuePropName: 'initialEditorState',
										})(<Input.TextArea />)}
									</Form.Item>
								</Card>
							</div>
							<div className="rowSpacing">
								<Card>
									<Form.Item label="Shipping terms" style={{ flex: 1 }}>
										{getFieldDecorator('shippingTerms', {
											initialValue:
												nullSafeGet('shippingTerms', formData) ||
												nullSafeGet('partEquipmentVendor.shippingTerms', formData),
											//valuePropName: 'initialEditorState',
										})(<Input.TextArea />)}
									</Form.Item>
								</Card>
							</div>
						</Col>
					</Row>
				</div>

				<div className="rowSpacing">
					<Card
						title="Parts"
						extra={
							canAddNewPRItems && [
								<Button className="ml-2" onClick={this.handleAddPRLineItem(false)}>
									Add Part
								</Button>,
							]
						}
					>
						{nullSafeGetOrElse('partSupplierPurchaseOrderLineItems', formData, []).length > 0 ? (
							<Table
								columns={poPartLineItemsColumns}
								rowKey={(part) => part['partId']}
								dataSource={sortById(formData.partSupplierPurchaseOrderLineItems || [])}
								loading={false}
							/>
						) : (
							<div className="flex flex-row justify-center">No part added!</div>
						)}
					</Card>
				</div>

				<div className="rowSpacing">
					<Card
						title="Equipment"
						extra={
							<div className="flex flex-row items-center gap-4">
								<StagingSLDropDown purchaseOrder={formData} onChange={this.onStagingSLChange} />
								{canAddNewPRItems ? (
									<Button onClick={this.handleAddPRLineItem(true)}>Add Equipment</Button>
								) : null}
							</div>
						}
					>
						{nullSafeGetOrElse('equipmentSupplierPurchaseOrderLineItems', formData, []).length >
						0 ? (
							<Table
								columns={poEquipmentLineItemsColumns}
								rowKey={(equipment) => equipment['equipmentTypeId']}
								dataSource={sortById(formData.equipmentSupplierPurchaseOrderLineItems || [])}
								loading={false}
							/>
						) : (
							<div className="flex flex-row justify-center">No equipment added!</div>
						)}
					</Card>
				</div>
				<div className="supplierPurchaseOrderForm">
					<div style={{ marginBottom: 32 }}>
						<div className="supplierPurchaseOrderForm__sectionHead">
							<div className="supplierPurchaseOrderForm__sectionHeadPrimary">Freight</div>
							<FormDots />
							<div className="supplierPurchaseOrderForm__sectionHeadSecondary">
								{getFieldDecorator(`freightTotalBeforeTax`, {
									validateTrigger: ['onBlur'],
									initialValue: nullSafeGetOrElse(`freightTotalBeforeTax`, formData, 0),
									rules: [
										{
											required: true,
											message: 'Please specify freight charges if any.',
										},
									],
								})(
									<InputNumber step={1} onChange={this.recalculateTotals} style={{ width: 240 }} />
								)}
							</div>
						</div>
					</div>
					<div style={{ marginBottom: 32 }}>
						<div className="supplierPurchaseOrderForm__sectionHead">
							<div className="supplierPurchaseOrderForm__sectionHeadPrimary">Miscellaneous</div>
							<FormDots />
							<div className="supplierPurchaseOrderForm__sectionHeadSecondary">
								{getFieldDecorator(`miscTotalBeforeTax`, {
									validateTrigger: ['onBlur'],
									initialValue: nullSafeGetOrElse(`miscTotalBeforeTax`, formData, 0),
									rules: [
										{
											required: true,
											message: 'Please specify miscellaneous charges if any.',
										},
									],
								})(
									<InputNumber step={1} onChange={this.recalculateTotals} style={{ width: 240 }} />
								)}
							</div>
						</div>
					</div>
					<div style={{ marginBottom: 32 }}>
						<div className="supplierPurchaseOrderForm__sectionHead">
							<div className="supplierPurchaseOrderForm__sectionHeadPrimary">Total Before Tax</div>
							<FormDots />
							<div className="supplierPurchaseOrderForm__sectionHeadSecondary">
								{currencyFormatter()(getFieldValue('totalBeforeTax'))}
							</div>
						</div>
					</div>
					<div style={{ marginBottom: 32 }}>
						<div className="supplierPurchaseOrderForm__sectionHead">
							<div className="supplierPurchaseOrderForm__sectionHeadPrimary">Tax</div>
							<FormDots />
							<div className="supplierPurchaseOrderForm__sectionHeadSecondary">
								{getFieldDecorator(`tax`, {
									validateTrigger: ['onBlur'],
									initialValue: nullSafeGetOrElse(`tax`, formData, 0),
									rules: [
										{
											required: true,
											message: 'Please specify tax if any.',
										},
									],
								})(
									<InputNumber step={1} onChange={this.recalculateTotals} style={{ width: 240 }} />
								)}
							</div>
						</div>
					</div>
					<div style={{ marginBottom: 32 }}>
						<div className="supplierPurchaseOrderForm__sectionHead">
							<div className="supplierPurchaseOrderForm__sectionHeadPrimary">Total With Tax</div>
							<FormDots />
							<div className="supplierPurchaseOrderForm__sectionHeadSecondary">
								{currencyFormatter()(getFieldValue('totalCost'))}
							</div>
						</div>
					</div>
				</div>
				<Form.Item>
					<OWButton type="primary" htmlType="submit" loading={this.state.creatingPO}>
						{submitText}
					</OWButton>
					<span style={{ marginLeft: '16px' }}>
						{onCancel ? (
							<Button onClick={onCancel}>Cancel</Button>
						) : (
							<BackButton buttonText="Cancel" />
						)}
					</span>
				</Form.Item>
				{this.state.editLineItemModalVisible ? (
					<EditPOLineItemModal
						cost={nullSafeGetWithZero('editingLineItemDetails.cost', this.state)}
						quantity={nullSafeGet('editingLineItemDetails.quantity', this.state)}
						title={nullSafeGet('editingLineItemDetails.title', this.state)}
						record={nullSafeGet('editingLineItemDetails.record', this.state)}
						partEquipmentVendorId={
							form.getFieldsValue(['partEquipmentVendorId']).partEquipmentVendorId
						}
						viaStockLocationId={nullSafeGet(
							'editingLineItemDetails.viaStockLocationId',
							this.state
						)}
						onCancel={this.hideEditLineItemModal}
						onSuccess={this.onEditLineItemSuccess}
						poCurrencyId={this.state.currencyId}
						allowViaStockLocation={allowViaStockLocation}
					/>
				) : null}

				{this.state.showAddPRLineItemsModal && (
					<AddLineItemsToPOModal
						isEquipmentLine={this.state.addPRLineItemsIsEquipmentLine}
						stockLocationId={stockLocationId}
						locationId={locationId}
						partEquipmentVendorId={
							form.getFieldsValue(['partEquipmentVendorId']).partEquipmentVendorId
						}
						existingPartLineItems={formData.partSupplierPurchaseOrderLineItems || []}
						existingEquipmentLineItems={formData.equipmentSupplierPurchaseOrderLineItems || []}
						onCancel={this.onAddPRLineItemsCancel}
						onAddLineItemsSuccess={this.onAddLineItemsSuccess}
					/>
				)}
			</Form>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	formData: ownProps.formData,
	redirectForwardUrl: ownProps.redirectForwardUrl,
	onSuccess: ownProps.onSuccess,

	createErrors: state.purchase_orders.createErrors,
	updateErrors: state.purchase_orders.updateErrors,
	creating: state.purchase_orders.creating,
	updating: state.purchase_orders.updating,
	purchaseRequests: state.purchase_requests,
	purchaseOrders: state.purchase_orders,
	stockLocations: state.stock_locations,
	vendors: state.vendors,
	currentUser: state.session.currentUser,
	onLineItemRemoved: ownProps.onLineItemRemoved,
	locations: state.locations,
	brands: state.brands,
	companySettings: state.company_config.detail,
});

const mapDispatchToProps = (dispatch) => ({
	update: (entity) => dispatch(purchaseOrdersRestCrudThunksForSupplier.update(entity)),
	create: (entity) => dispatch(purchaseOrdersRestCrudThunksForSupplier.create(entity)),
	createLineItemsBulk: (entities) =>
		dispatch(purchaseOrderLineItemsRestCrudThunksForSupplier.createBulk(entities)),
	associatePurchaseRequestLineItemToPurchaseOrder: (ids, purchaseOrderId) =>
		dispatch(associatePurchaseRequestLineItemToPurchaseOrderForSupplier(ids, purchaseOrderId)),
	fetchPurchaseRequests: (params, targetCollectionName) =>
		dispatch(purchaseRequestsRestCrudThunksForSupplier.read(params, targetCollectionName)),
	fetchStockLocations: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			stockLocationsRestCrudThunksForSupplier.read(
				{ ...params, noIsActiveFilter: false },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleStockLocations: (ids, targetCollectionName) =>
		dispatch(stockLocationsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchVendor: (id) => dispatch(vendorsRestCrudThunksForSupplier.readOne(id)),
	fetchVendors: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			vendorsRestCrudThunksForSupplier.read(
				{ ...(params || {}), isActive: true },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleVendors: (ids, targetCollectionName) =>
		dispatch(vendorsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchLocations: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			locationsRestCrudThunksForSupplier.readLite(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleLocations: (ids, targetCollectionName) =>
		dispatch(locationsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchBrands: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			brandsRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleBrands: (ids, targetCollectionName) =>
		dispatch(brandsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchPartCatalog: (params) => dispatch(partCatalogsRestCrudThunksForSupplier.read(params)),
	fetchEquipmentCatalog: (params) =>
		dispatch(equipmentCatalogsRestCrudThunksForSupplier.read(params)),
});

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(Form.create<PurchaseOrderFormProps>()(PurchaseOrderForm))
);
